export const koMessages = {
  setup: {
    welcomeTitle: "%{title}에 오신 것을 환영합니다",
    welcomeSubtitle: "시작하려면 Supabase 데이터베이스에 연결해야 합니다.",
    encryptedTitle: "보안",
    encryptedDesc: "데이터는 AES-256으로 보호됩니다",
    turboTitle: "터보",
    turboDesc: "속도와 확장성을 위해 최적화되었습니다",
    getStarted: "시작하기",
    connectionMode: "연결 모드",
    selectVector: "초기화 벡터를 선택하십시오",
    quickIgnition: "빠른 점화",
    autoProvision: "토큰을 통한 자동 프로비저닝",
    manualSync: "수동 동기화",
    existingCredentials: "기존 자격 증명 사용",
    abortAccess: "액세스 중단",
    injectCoordinates: "데이터베이스 좌표 주입",
    platformUrl: "플랫폼 URL",
    urlHelp: "Project Settings > API > Project URL에서 찾을 수 있습니다",
    anonMatrixKey: "Anon / Matrix 키",
    keyHelp: "Project Settings > API > anon (public) 키에서 찾을 수 있습니다",
    back: "뒤로",
    engage: "연결",
    managedTokenTitle: "포지 토큰",
    managedTokenSubtitle: "Supabase API 좌표",
    personalAccessToken: "개인 액세스 토큰",
    generateAt: "생성 위치",
    scanOrgs: "조직 스캔",
    projectConfigTitle: "프로젝트 구성",
    engineParameters: "엔진 파라미터",
    projectName: "프로젝트 이름",
    hostingSector: "호스팅 섹터",
    vesselOrg: "베슬 (조직)",
    initializeSystem: "시스템 초기화",
    provisioning: "프로비저닝 중",
    provisioningFailed: "프로비저닝 실패",
    provisioningFailedDetails:
      "프로비저닝에 실패했습니다. 자세한 내용은 위 로그를 확인하세요.",
    assemblingInfrastructure: "인프라 구축 중...",
    checkLogs: "자세한 내용은 로그를 확인하십시오",
    tryAgain: "다시 시도",
    useManualConnect: "대신 수동 연결 사용",
    installationComplete: "설치 완료",
    installingDatabase: "데이터베이스 설치 중",
    applyingSchemaDna: "스키마 DNA 적용 중...",
    systemReady: "시스템 준비 완료!",
    tokenRequired: "토큰 필요",
    readyToInstall: "설치 준비 완료",
    managementToken: "관리 토큰",
    installDatabaseSchema: "데이터베이스 스키마 설치",
    retryInstallation: "설치 다시 시도",
    projectIdRequired: "마이그레이션을 위해 프로젝트 ID가 필요합니다.",
    tokenDescription:
      "데이터베이스 스키마를 설치하고 기존 사용자를 동기화하려면 Supabase 액세스 토큰이 필요합니다.",
    connectingProvisioning: "Supabase 프로비저닝 엔진에 연결 중...",
    projectReady: "✨ 프로젝트 준비 완료! 데이터베이스 초기화 중...",
    startingMigration: "데이터베이스 마이그레이션 시작 중...",
    setupCompleteLog: "🎉 설정 완료!",
    checkingDatabase: "데이터베이스 상태 확인 중...",
    dbNotInitialized:
      "데이터베이스가 초기화되지 않았습니다. 스키마 설정을 위해 마이그레이션이 필요합니다.",
    dbVersionBehind:
      "데이터베이스 버전(%{dbVersion})이 앱 버전(%{appVersion})보다 낮습니다. 마이그레이션을 권장합니다.",
    dbLegacySchema:
      "데이터베이스가 레거시 스키마를 사용하지만 이미 초기화되어 작동 중입니다.",
    skippingMigration:
      "✅ 마이그레이션을 건너뜁니다. 데이터베이스가 준비되었습니다!",
    reloadingApp: "새로운 자격 증명으로 앱을 다시 로드하는 중...",
    dbReady: "✅ 데이터베이스가 이미 설정되어 준비되었습니다!",
    setupComplete: "설정 완료!",
    redirecting: "CRM으로 리다이렉트 중...",
    liveFeed: "라이브 피드",
    awaitingSignals: "커널 신호 대기 중...",
  },
  crm: {
    root: {
      database_checking: "데이터베이스 연결 확인 중...",
    },
    changelog: {
      title: "새로운 기능",
    },
    setup_wizard: {
      welcome: {
        title: "%{title}에 오신 것을 환영합니다",
        subtitle: "데이터베이스 구성",
        description: "시작하려면 Supabase 데이터베이스에 연결해야 합니다.",
        no_project: "Supabase 프로젝트가 없으신가요?",
        create_free: "여기에서 무료로 생성하세요:",
        need_title: "준비할 것:",
        need_url: "Supabase 프로젝트 URL 또는 프로젝트 ID",
        need_key: "API 키 (anon 또는 publishable 키)",
        find_hint: "어디서 찾을 수 있나요?",
        continue: "계속",
      },
      credentials: {
        title: "Supabase 연결",
        description: "Supabase 프로젝트 자격 증명을 입력하세요",
        url_label: "프로젝트 URL 또는 ID",
        url_placeholder: "xxxxx 또는 https://xxxxx.supabase.co",
        url_valid: "유효한 Supabase URL",
        url_project_id: "유효한 프로젝트 ID (전체 URL로 확장됨)",
        url_invalid_format: "잘못된 URL 형식",
        url_must_be_supabase: "URL은 Supabase 도메인이어야 합니다",
        url_hint: "전체 URL 또는 프로젝트 ID 입력",
        url_expansion: "%{url}로 확장됩니다",
        url_default_hint:
          "전체 URL 또는 프로젝트 ID만 입력하세요 (프로젝트 설정 → API)",
        key_label: "API 키",
        key_placeholder: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...",
        key_valid_publishable: "유효한 publishable 키 형식",
        key_valid_anon: "유효한 anon 키 형식",
        key_incomplete_publishable: "publishable 키가 불완전한 것 같습니다",
        key_incomplete_anon: "anon 키가 불완전한 것 같습니다",
        key_invalid: "유효한 Supabase API 키(anon 또는 publishable)여야 합니다",
        key_default_hint: "Anon 또는 Publishable 키 (프로젝트 설정 → API)",
        back: "뒤로",
        connect: "연결",
        error_failed: "연결 실패",
      },
      validating: {
        title: "연결 확인 중",
        description: "Supabase 자격 증명을 테스트하는 중...",
        wait: "잠시만 기다려주세요...",
      },
      success: {
        title: "연결 성공!",
        description: "Supabase 데이터베이스가 연결되었습니다",
        reloading: "애플리케이션 다시 로드 중...",
      },
    },
    nav: {
      dashboard: "대시보드",
      contacts: "연락처",
      companies: "회사",
      deals: "딜",
      invoices: "청구서",
      tasks: "작업",
      ai: "AI",
      users: "사용자",
      settings: "내 정보",
      database: "데이터베이스",
      integrations: "연동",
      back: "뒤로",
    },
    view: {
      table: "테이블",
      kanban: "칸반",
    },
    action: {
      new_task: "새 작업",
      new_deal: "새 딜",
    },
    filter: {
      active: "활성",
      active_filters: "활성 필터",
      contact: "연락처",
      company: "회사",
      deal: "딜",
      loading: "로딩 중...",
      my_tasks: "내 작업",
      assigned_to: "담당자",
      archived: "보관됨",
      priority: "우선순위",
      remove: "%{filter} 필터 제거",
      search: "검색",
      status: "상태",
    },
    dashboard: {
      invoice_revenue: "송장 매출",
      deal_pipeline: "딜 파이프라인",
      upcoming_tasks: "다가오는 작업",
      task_filters: {
        overdue: "기한 지남",
        today: "오늘",
        tomorrow: "내일",
        this_week: "이번 주",
        later: "나중에",
      },
      load_more: "더 보기",
      tasks_empty: "현재 할 일이 없습니다.",
      upcoming_deal_revenue: "예상 거래 매출",
      revenue: "수익",
      outstanding_invoices: "미결제 송장",
      deals_chart: {
        won: "성공",
        lost: "실패",
      },
      hot_contacts: "핫 연락처",
      create_contact: "연락처 만들기",
      hot_contacts_empty: {
        line_1: "아직 핫 연락처가 없습니다.",
        line_2: "연락처를 만들어 시작하세요.",
      },
      latest_activity: "최근 활동",
      latest_notes: "최근 노트",
      notes: {
        on: "관련",
        added: "추가됨",
        deal: "거래",
        contact: "연락처",
      },
      pipeline: {
        title: "거래 파이프라인",
      },
      stepper: {
        title: "시작하기",
        progress: "%{total}개 중 %{step}개",
        install: "앱 설치",
        add_contact: "첫 연락처 추가",
        new_contact: "새 연락처",
        add_note: "노트 추가",
        add_note_hint: "첫 연락처에 노트를 추가하세요.",
        add_note_button: "노트 추가",
      },
      welcome: {
        title: "환영합니다",
        body_1: "는 로컬에서 실행할 수 있는 풀 기능 CRM입니다.",
        body_2: "연락처, 회사, 거래, 작업이 기본 제공됩니다.",
        powered_by: "제공:",
        fork_of: "는",
        by_marmelab: "의 Marmelab 포크입니다.",
      },
    },
    task: {
      column: {
        expand: "%{column} 열 펼치기",
        collapse: "%{column} 열 접기",
      },
      field: {
        task: "작업",
        type: "유형",
        related_to: "관련",
        description: "설명",
        due_date: "마감일",
        completed: "완료",
        priority: "우선순위",
        status: "상태",
        assigned_to: "담당자",
        created_by: "작성자",
        actions: "동작",
      },
      action: {
        create_task: "작업 생성",
        add_task: "작업 추가",
        edit_task: "작업 편집",
        edit: "편집",
        mark_complete: "완료로 표시",
        snooze_tomorrow: "내일까지 미루기",
        postpone_day: "하루 미루기",
        show_details: "세부 정보 보기",
        postpone_tomorrow: "내일로 미루기",
        postpone_next_week: "다음 주로 미루기",
        menu: "작업 메뉴",
      },
      notification: {
        marked_complete: "작업을 완료로 표시했습니다",
        snoozed_tomorrow: "작업을 내일까지 미뤘습니다",
        postponed_day: "작업을 하루 미뤘습니다",
        created: "작업이 생성되었습니다",
        updated: "작업이 업데이트되었습니다",
        deleted: "작업이 삭제되었습니다",
        deleted_success: "작업이 성공적으로 삭제되었습니다",
        move_failed: "작업을 이동할 수 없습니다. 다시 시도하세요.",
      },
      note: {
        marked_complete: "빠른 작업으로 완료 처리됨",
        marked_complete_quick: "빠른 작업으로 완료 표시",
        snoozed_to_date: "마감일을 %{date}로 미룸",
        postponed_to_date: "마감일을 %{date}로 연기",
        quick_edit: "빠른 편집으로 작업 업데이트됨",
      },
      section: {
        info: "정보",
        related: "관련",
        assignment: "할당",
        activity_timeline: "활동 타임라인",
        activity_description: "이 작업의 상태 변경 및 업데이트를 추적합니다",
        notes: "노트",
        notes_description: "이 작업에 노트와 업데이트를 추가하세요",
      },
      related: {
        none: "연결된 항목 없음",
        prefix: "관련:",
      },
      entity_type: {
        link_to: "%{type}에 연결",
        none: "없음",
        contact: "연락처",
        company: "회사",
        deal: "거래",
      },
      due: {
        label: "기한",
        relative: "기한 %{time}",
        no_date: "기한 없음",
        overdue_one: "1일 지남",
        overdue_many: "%{count}일 지남",
        today: "오늘까지",
        tomorrow: "내일까지",
        in_days_one: "1일 후 마감",
        in_days_many: "%{count}일 후 마감",
      },
      activity: {
        loading: "활동 로딩 중...",
        empty: "기록된 활동이 없습니다.",
        created: "이 작업을 생성했습니다",
        updated: "이 작업을 업데이트했습니다",
        updated_field: "%{field}를 변경했습니다",
        assigned: "이 작업을 할당했습니다",
        completed: "이 작업을 완료했습니다",
        reopened: "이 작업을 다시 열었습니다",
        duplicated: "이 작업을 복제했습니다",
        archived: "이 작업을 보관했습니다",
        truncated:
          "%{total}개 중 %{count}개 활동을 표시합니다. 이전 활동은 표시되지 않습니다.",
      },
      dialog: {
        edit: {
          title: "작업 편집",
          description: "작업 세부 정보, 할당 및 관련 항목을 업데이트합니다",
        },
        create: {
          title: "새 작업 만들기",
          title_for: "%{name}에 대한 새 작업 만들기",
          this_record: "이 레코드",
          description: "설명, 마감일, 담당 정보를 포함한 새 작업을 추가합니다",
        },
      },
      status: {
        todo: "할 일",
        in_progress: "진행 중",
        blocked: "차단됨",
        done: "완료",
        cancelled: "취소됨",
        other: "기타",
      },
      priority: {
        low: "낮음",
        medium: "보통",
        high: "높음",
        urgent: "긴급",
      },
      type: {
        none: "없음",
        email: "이메일",
        demo: "데모",
        lunch: "점심",
        meeting: "회의",
        follow_up: "후속 조치",
        thank_you: "감사",
        ship: "배송",
        call: "전화",
      },
    },
    note: {
      placeholder: "노트 추가",
      show_options: "옵션 표시",
      options_hint: "(파일 첨부 또는 세부 정보 변경)",
      date: "날짜",
      added: "노트가 추가되었습니다",
      action: {
        add: "이 노트 추가",
      },
      status: {
        cold: "콜드",
        warm: "웜",
        hot: "핫",
        in_contract: "계약 중",
      },
    },
    activity: {
      added_note: "노트를 추가했습니다",
      added_note_about: "에 대한 노트를 추가했습니다",
      added_note_about_deal: "딜에 대한 노트를 추가했습니다",
      at: "회사:",
      edit_note: "노트 편집",
      delete_note: "노트 삭제",
      note_deleted: "노트가 삭제되었습니다",
      cancel: "취소",
      update_note: "노트 업데이트",
      added_deal: "딜을 추가했습니다",
      to_company: "회사:",
      added_company: "회사를 추가했습니다",
      added: "추가했습니다",
      pagination: "%{total}개 활동 중 %{from}-%{to} 표시",
      error_load: "활동 로그를 불러오지 못했습니다",
    },
    deal: {
      field: {
        name: "딜 이름",
        description: "설명",
        amount: "금액",
        expected_closing_date: "예상 마감일",
        stage: "단계",
        category: "카테고리",
        account_manager: "소유자",
        budget: "예산",
      },
      section: {
        linked_to: "연결됨",
        misc: "기타",
        deal_info: "딜 정보",
        company: "회사",
        contacts: "연락처",
        assignment: "할당",
        notes: "노트",
        notes_description: "이 딜에 대한 대화, 결정 및 업데이트를 추적합니다",
      },
      action: {
        edit: "딜 편집",
        create: "딜 만들기",
        archive: "보관",
        unarchive: "보관 해제",
        view_archived: "보관된 딜 보기",
      },
      notification: {
        archived: "딜이 보관되었습니다",
        unarchived: "딜이 보관 해제되었습니다",
        error_archiving: "오류: 딜을 보관하지 못했습니다",
        error_unarchiving: "오류: 딜을 보관 해제하지 못했습니다",
      },
      empty: {
        title: "딜을 찾을 수 없음",
        description: "딜 목록이 비어 있는 것 같습니다.",
        no_contacts: "연락처 목록이 비어 있는 것 같습니다.",
        add_contact: "첫 연락처 추가",
        before_creating: "후에 딜을 만들어주세요.",
      },
      status: {
        archived: "보관됨",
        past: "과거",
        invalid_date: "유효하지 않은 날짜",
      },
      placeholder: {
        select_company: "연락처를 보려면 먼저 회사를 선택하세요",
      },
      filter: {
        only_companies_i_manage: "내가 관리하는 회사만",
      },
      list: {
        archived_title: "보관된 딜",
      },
      stage: {
        opportunity: "기회",
        proposal_sent: "제안 발송됨",
        in_negociation: "협상 중",
        won: "성공",
        lost: "실패",
        delayed: "지연",
      },
      category: {
        other: "기타",
        copywriting: "카피라이팅",
        print_project: "인쇄 프로젝트",
        ui_design: "UI 디자인",
        website_design: "웹사이트 디자인",
      },
    },
    contact: {
      gender: {
        male: "그/그",
        female: "그녀/그녀",
        nonbinary: "그들/그들",
      },
      field: {
        first_name: "이름",
        last_name: "성",
        title: "직함",
        company: "회사",
        email: "이메일",
        email_addresses: "이메일 주소",
        phone_number: "전화번호",
        phone_numbers: "전화번호",
        linkedin_url: "LinkedIn URL",
        background: "배경 정보 (약력, 알게 된 경위 등)",
        has_newsletter: "뉴스레터 구독",
        account_manager: "계정 관리자",
        first_seen: "추가됨",
        last_seen_on: "최근 활동:",
        followed_by: "팔로우 중:",
        subscribed_to_newsletter: "뉴스레터 구독 중",
        linkedin: "LinkedIn",
        at: "회사:",
      },
      section: {
        identity: "신원",
        position: "직책",
        personal_info: "개인 정보",
        misc: "기타",
        activity_timeline: "활동 타임라인",
        activity_timeline_description: "들어오는 활동의 실시간 처리 상태",
        notes: "노트",
        notes_description: "상호작용 및 결과의 영구 기록",
        background_info: "배경 정보",
        tags: "태그",
        tasks: "작업",
      },
      action: {
        edit: "연락처 편집",
        show: "연락처 보기",
        create: "새 연락처",
        export_vcard: "vCard 내보내기",
        merge_with_another: "다른 연락처와 병합",
        import: "가져오기",
      },
      type: {
        work: "직장",
        home: "집",
        other: "기타",
      },
      empty: {
        title: "연락처를 찾을 수 없음",
        description: "연락처 목록이 비어 있는 것 같습니다.",
      },
      filter: {
        last_activity: "최근 활동",
        today: "오늘",
        this_week: "이번 주",
        before_this_week: "이번 주 이전",
        before_this_month: "이번 달 이전",
        before_last_month: "지난 달 이전",
        engagement: "참여도",
        engagement_status: {
          strong: "강함",
          active: "활성",
          cooling: "식음",
          cold: "콜드",
          dormant: "휴면",
        },
        validation: "검증",
        validation_status: {
          valid: "유효한 이메일",
          risky: "위험 이메일",
          invalid: "무효한 이메일",
        },
        tags: "태그",
        tasks: "작업",
        with_pending_tasks: "보류 중인 작업 있음",
        account_manager: "계정 관리자",
        me: "나",
        search_placeholder: "이름, 회사 검색...",
      },
      health: {
        title: "연락처 상태",
        no_data: "아직 계산된 상태 데이터가 없습니다.",
        relationship_strength: "관계 강도",
        engagement_score: "참여 점수",
        last_activity: "최근 활동: ",
        days_ago: "%{days}일 전",
        today: "오늘",
        yesterday: "어제",
        contact_validation: "연락처 검증",
        bounced: "(반송됨)",
        validated: "검증됨",
        status: {
          valid: "유효함",
          risky: "위험",
          invalid: "무효",
          active: "활성",
          inactive: "비활성",
          not_found: "찾을 수 없음",
        },
      },
      merge: {
        title: "연락처 병합",
        description: "이 연락처를 다른 연락처와 병합합니다.",
        current_contact: "현재 연락처 (삭제됨)",
        target_contact: "대상 연락처 (유지됨)",
        what_will_be_merged: "병합될 항목:",
        notes_to_merge:
          "%{count}개의 노트가 다시 할당됩니다 |||| %{count}개의 노트가 다시 할당됩니다",
        tasks_to_merge:
          "%{count}개의 작업이 다시 할당됩니다 |||| %{count}개의 작업이 다시 할당됩니다",
        deals_to_merge:
          "%{count}개의 딜이 업데이트됩니다 |||| %{count}개의 딜이 업데이트됩니다",
        emails_to_merge:
          "%{count}개의 이메일 주소가 추가됩니다 |||| %{count}개의 이메일 주소가 추가됩니다",
        phones_to_merge:
          "%{count}개의 전화번호가 추가됩니다 |||| %{count}개의 전화번호가 추가됩니다",
        no_data: "병합할 추가 데이터가 없습니다",
        warning_title: "경고: 파괴적인 작업",
        warning_message:
          "모든 데이터가 두 번째 연락처로 이전됩니다. 이 작업은 되돌릴 수 없습니다.",
        merging: "병합 중...",
        merge_contacts: "연락처 병합",
        select_contact: "병합할 연락처를 선택하세요",
        success: "연락처가 성공적으로 병합되었습니다",
        error: "연락처 병합에 실패했습니다",
      },
      import: {
        title: "가져오기",
        description: "CSV 파일에서 연락처 가져오기",
        running: "가져오기가 실행 중입니다. 이 탭을 닫지 마세요.",
        status:
          "%{total}개 중 %{count}개 연락처를 가져왔습니다(오류: %{errors}개)",
        remaining_time: "예상 남은 시간: %{time}",
        stop: "가져오기 중단",
        error: "가져오기에 실패했습니다. 올바른 CSV 파일인지 확인하세요.",
        complete:
          "연락처 가져오기가 완료되었습니다. %{count}개를 가져왔습니다(오류: %{errors}개)",
        template_hint: "템플릿으로 사용할 수 있는 샘플 CSV 파일입니다",
        download_sample: "CSV 샘플 다운로드",
        csv_file: "CSV 파일",
      },
    },
    company: {
      sector: {
        communication_services: "커뮤니케이션 서비스",
        consumer_discretionary: "경기소비재",
        consumer_staples: "필수소비재",
        energy: "에너지",
        financials: "금융",
        health_care: "헬스케어",
        industrials: "산업재",
        information_technology: "정보기술",
        materials: "소재",
        real_estate: "부동산",
        utilities: "유틸리티",
      },
      field: {
        name: "이름",
        website: "웹사이트",
        phone_number: "전화번호",
        linkedin: "LinkedIn",
        twitter: "Twitter/X",
        facebook: "Facebook",
        github: "GitHub",
        logo_url: "로고 URL",
        lifecycle_stage: "라이프사이클 단계",
        company_type: "회사 유형",
        qualification_status: "적격성 상태",
        employee_count: "직원 수",
        revenue_range: "매출 범위",
        founded_year: "설립 연도",
        tax_identifier: "사업자 등록 번호",
        address: "주소",
        city: "도시",
        zipcode: "우편번호",
        state: "주/도",
        country: "국가",
        description: "설명",
        account_manager: "계정 관리자",
        first_seen: "추가됨",
        followed_by: "팔로우 중",
        size: "규모",
        revenue: "매출",
        sector: "섹터",
        context_links: "컨텍스트 링크",
      },
      section: {
        contact: "연락처",
        social_profiles: "소셜 프로필",
        context: "컨텍스트",
        address: "주소",
        additional_info: "추가 정보",
        advanced_settings: "고급 설정",
        external_system_integration: "외부 시스템 연동",
        company_info: "회사 정보",
        main_address: "기본 주소",
      },
      action: {
        edit: "회사 편집",
        show: "회사 보기",
        create: "회사 만들기",
        merge_with_another: "다른 회사와 병합",
      },
      empty: {
        title: "회사를 찾을 수 없음",
        description: "회사 목록이 비어 있는 것 같습니다.",
      },
      placeholder: {
        external_id: "예: Salesforce 계정 ID",
        company_name: "회사 이름",
        create_hint: "입력하여 새 회사 만들기",
      },
      error: {
        invalid_url: "유효한 URL이어야 합니다",
      },
      notification: {
        error_creating: "회사 생성 중 오류가 발생했습니다",
      },
      filter: {
        me: "나",
      },
      health: {
        title: "회사 상태",
        internal_engagement: "내부 참여",
        engagement_score: "참여 점수",
        last_activity: "최근 활동: ",
        today: "오늘",
        yesterday: "어제",
        days_ago: "%{days}일 전",
        updated: "업데이트됨",
        external_health: "외부 상태",
        last_checked: "최근 확인",
        status: {
          engaged: "참여함",
          quiet: "조용함",
          at_risk: "위험함",
          unresponsive: "응답 없음",
          healthy: "정상",
          risky: "위험",
          dead: "중단",
          unknown: "알 수 없음",
        },
      },
      size: {
        1: "직원 1명",
        10: "직원 2-9명",
        50: "직원 10-49명",
        250: "직원 50-249명",
        500: "직원 250명 이상",
      },
      merge: {
        title: "회사 병합",
        description: "이 회사를 다른 회사와 병합합니다.",
        current_contact: "현재 회사 (삭제됨)",
        target_contact: "대상 회사 (유지됨)",
        what_will_be_merged: "병합될 항목:",
        contacts_to_merge:
          "%{count}개의 연락처가 다시 할당됩니다 |||| %{count}개의 연락처가 다시 할당됩니다",
        deals_to_merge:
          "%{count}개의 딜이 다시 할당됩니다 |||| %{count}개의 딜이 다시 할당됩니다",
        links_to_merge:
          "%{count}개의 컨텍스트 링크가 추가됩니다 |||| %{count}개의 컨텍스트 링크가 추가됩니다",
        no_data: "병합할 추가 데이터가 없습니다",
        warning_title: "경고: 파괴적인 작업",
        warning_message:
          "모든 데이터가 두 번째 회사로 이전됩니다. 이 작업은 되돌릴 수 없습니다.",
        merging: "병합 중...",
        merge_companies: "회사 병합",
        select_company: "병합할 회사를 선택하세요",
        success: "회사가 성공적으로 병합되었습니다",
        error: "회사 병합에 실패했습니다",
      },
    },
    tag: {
      action: {
        add: "태그 추가",
        create: "새 태그 만들기",
      },
    },
    integrations: {
      title: "연동",
      description:
        "API 키, 웹훅 및 인입 채널을 관리하여 RealTimeX CRM을 외부 시스템과 연동합니다.",
      tabs: {
        ingestion: "인입 채널",
        file_upload: "파일 업로드",
        api_keys: "API 키",
        webhooks: "웹훅 (아웃바운드)",
      },
      webhooks: {
        description:
          "웹훅은 CRM에서 이벤트가 발생할 때 외부 시스템에 알림을 보냅니다.",
        action: {
          create: "웹훅 생성",
          create_first: "첫 번째 웹훅 생성",
          edit: "웹훅 편집",
          delete: "삭제",
          update: "업데이트",
        },
        empty: "아직 웹훅이 없습니다",
        loading: "로딩 중...",
        status: {
          active: "활성",
          inactive: "비활성",
          more: "+%{count}개 더보기",
        },
        fields: {
          name: "이름",
          url: "웹훅 URL",
          events: "구독할 이벤트",
          created: "생성일: %{date}",
          last_triggered: "최근 실행: %{date}",
          failed_deliveries: "전송 실패: %{count}",
        },
        dialog: {
          create_title: "웹훅 생성",
          create_description: "이벤트 알림을 받을 새 웹훅을 만듭니다",
          edit_title: "웹훅 편집",
          edit_description: "웹훅 설정을 업데이트합니다",
          delete_title: "웹훅을 삭제하시겠습니까?",
          delete_description:
            "이 웹훅을 영구적으로 삭제합니다. 더 이상 이 엔드포인트로 이벤트가 전송되지 않습니다. 이 작업은 되돌릴 수 없습니다.",
        },
        placeholder: {
          name: "예: Slack 알림",
          url: "https://example.com/webhook",
        },
        notification: {
          created: "웹훅이 성공적으로 생성되었습니다",
          updated: "웹훅이 성공적으로 업데이트되었습니다",
          deleted: "웹훅이 성공적으로 삭제되었습니다",
          error_creating: "웹훅 생성에 실패했습니다",
          error_updating: "웹훅 업데이트에 실패했습니다",
          error_deleting: "웹훅 삭제에 실패했습니다",
        },
        categories: {
          contacts: "연락처",
          companies: "기업",
          deals: "거래",
          tasks: "할 일",
          invoices: "송장",
        },
        events: {
          "contact.created": "연락처 생성됨",
          "contact.updated": "연락처 업데이트됨",
          "contact.deleted": "연락처 삭제됨",
          "company.created": "회사 생성됨",
          "company.updated": "회사 업데이트됨",
          "company.deleted": "회사 삭제됨",
          "deal.created": "딜 생성됨",
          "deal.updated": "딜 업데이트됨",
          "deal.deleted": "딜 삭제됨",
          "deal.stage_changed": "딜 단계 변경됨",
          "deal.won": "딜 성공",
          "deal.lost": "딜 실패",
          "task.created": "작업 생성됨",
          "task.updated": "작업 업데이트됨",
          "task.assigned": "작업 할당됨",
          "task.completed": "작업 완료됨",
          "task.priority_changed": "작업 우선순위 변경됨",
          "task.archived": "할 일이 아카이브됨",
          "task.deleted": "할 일이 삭제됨",
          "invoice.created": "송장이 생성됨",
          "invoice.updated": "송장이 업데이트됨",
          "invoice.deleted": "송장이 삭제됨",
          "invoice.status_changed": "송장 상태가 변경됨",
          "invoice.sent": "송장이 전송됨",
        },
      },
      api_keys: {
        description:
          "API 키를 사용하면 외부 애플리케이션에서 CRM 데이터에 프로그래밍 방식으로 액세스할 수 있습니다.",
        action: {
          create: "API 키 생성",
          create_first: "첫 번째 API 키 생성",
          copy: "복사",
          copied: "전체 API 키가 클립보드에 복사되었습니다",
          done: "완료",
        },
        empty: "아직 API 키가 없습니다",
        loading: "로딩 중...",
        fields: {
          name: "이름",
          created: "생성일: %{date}",
          last_used: "최근 사용: %{date}",
          expires: "만료일: %{date}",
          key_hint: "복사를 클릭하여 마스킹되지 않은 전체 키를 가져옵니다",
          not_available: "복사할 수 있는 API 키가 없습니다",
          scopes: "범위",
          expiration: "만료일 (선택 사항)",
          your_api_key: "귀하의 API 키",
        },
        dialog: {
          create_title: "API 키 생성",
          create_description:
            "CRM API에 액세스하기 위한 새 API 키를 생성합니다",
          created_title: "API 키 생성됨",
          created_description:
            "지금 이 키를 복사하십시오 - 다시는 표시되지 않습니다!",
          delete_title: "API 키를 삭제하시겠습니까?",
          delete_description:
            "이 API 키를 영구적으로 삭제합니다. 이 키를 사용하는 모든 애플리케이션이 즉시 작동을 멈춥니다. 이 작업은 되돌릴 수 없습니다.",
          warning_copy:
            "지금 API 키를 복사했는지 확인하십시오. 다시는 볼 수 없습니다!",
        },
        placeholder: {
          name: "예: 운영용 API 키",
        },
        scopes: {
          "contacts:read": "연락처: 읽기",
          "contacts:write": "연락처: 쓰기",
          "companies:read": "회사: 읽기",
          "companies:write": "회사: 쓰기",
          "deals:read": "딜: 읽기",
          "deals:write": "딜: 쓰기",
          "tasks:read": "할 일: 읽기",
          "tasks:write": "할 일: 쓰기",
          "invoices:read": "송장: 읽기",
          "invoices:write": "송장: 쓰기",
          "activities:write": "활동: 쓰기 (메모)",
        },
        notification: {
          deleted: "API 키가 성공적으로 삭제되었습니다",
          error_deleting: "API 키 삭제에 실패했습니다",
          error_copying: "API 키 복사에 실패했습니다",
        },
      },
      file_upload: {
        title: "파일 업로드",
        description:
          "문서, 이미지, 오디오 또는 비디오 파일을 업로드하여 활동을 생성합니다. 파일은 자동으로 저장되어 계정에 연결됩니다.",
        action: {
          upload: "업로드",
          upload_all: "모두 업로드",
          clear_completed: "완료된 항목 지우기",
          drop_files: "여기에 파일 놓기...",
          drag_and_drop: "파일을 여기에 드래그 앤 드롭하거나 클릭하여 선택",
          supports_all: "모든 파일 형식 지원 (보안을 위해 실행 파일은 차단됨)",
        },
        fields: {
          ingestion_channel: "인입 채널",
          activity_type: "활동 유형",
          select_channel: "채널 선택...",
          files_count: "파일 (%{count}개)",
        },
        types: {
          note: "노트",
          email: "이메일",
          call: "통화 녹음",
          meeting: "회의 녹음",
          other: "기타",
        },
        how_it_works: {
          title: "작동 방식",
          step_1:
            "파일이 보안 저장소에 직접 업로드됩니다 (데이터베이스 비대화 방지)",
          step_2: "각 파일은 추적 및 검색을 위한 활동 기록을 생성합니다",
          step_3: "대용량 파일은 자동으로 처리됩니다 (크기 제한 없음)",
          step_4: "파일이 선택한 인입 채널에 연결됩니다",
          step_5: "활동이 활동 피드에 즉시 나타납니다",
        },
        notification: {
          select_channel: "인입 채널을 선택하세요",
          success: "파일 업로드됨: %{name}",
          error: "업로드 실패: %{name}",
          error_network: "네트워크 오류",
          error_status: "업로드 실패 (상태 코드: %{status})",
          error_dangerous: "보안상의 이유로 실행 파일은 허용되지 않습니다",
        },
      },
      ingestion: {
        title: "인입 채널",
        description:
          "CRM으로 활동을 가져오기 위한 인입 채널(이메일, 음성, SMS)을 구성합니다.",
        action: {
          create: "채널 생성",
          add: "인입 채널 추가",
          add_first: "첫 번째 채널 추가",
          copy_url: "웹훅 URL 복사",
          url_copied: "웹훅 URL이 클립보드에 복사되었습니다",
        },
        empty: "구성된 인입 채널이 없습니다",
        loading: "로딩 중...",
        fields: {
          webhook_url: "웹훅 URL",
          created: "생성일: %{date}",
        },
        dialog: {
          create_description: "들어오는 활동에 대한 새로운 소스를 구성합니다.",
          name_label: "채널 이름",
          provider_label: "제공자",
          token_label: "인증 토큰 (검증)",
          token_hint: "인바운드 요청을 검증하는 데 필요합니다.",
          placeholder_name: "예: 미국 지원 라인",
          placeholder_token: "Twilio 인증 토큰",
          select_provider: "제공자 선택",
          delete_title: "채널을 삭제하시겠습니까?",
          delete_description:
            "이 소스에서의 모든 수집이 중단됩니다. 이 작업은 되돌릴 수 없습니다.",
        },
        providers: {
          twilio: "Twilio (음성/SMS)",
          postmark: "Postmark (이메일)",
          generic: "일반 / 내부",
        },
        notification: {
          created: "인입 채널이 성공적으로 생성되었습니다",
          deleted: "채널이 삭제되었습니다",
          error_creating: "채널 생성 실패: %{message}",
          error_deleting: "채널 삭제에 실패했습니다",
        },
      },
    },
    image_editor: {
      action: {
        change: "변경",
        update: "이미지 업데이트",
        delete: "삭제",
      },
      dialog: {
        title: "이미지 업로드 및 크기 조정",
        dropzone: "파일을 드래그하여 업로드하거나 클릭하여 선택하세요.",
      },
      alt: "편집 가능한 콘텐츠",
    },
    document_viewer: {
      error: {
        docx: "DOCX 콘텐츠 렌더링에 실패했습니다.",
        too_large: "파일이 너무 큽니다 (최대 50MB). 크기: %{size}MB",
        not_available: "이 파일 형식의 미리보기를 사용할 수 없습니다.",
        access:
          "파일에 액세스할 수 없습니다. 네트워크 문제, CORS 제한 또는 만료된 링크일 수 있습니다.",
        load: "문서 미리보기를 불러오지 못했습니다.",
      },
      action: {
        download: "파일 다운로드",
        open_new_tab: "새 탭에서 열기",
      },
    },
    email_viewer: {
      error: {
        parse: "이메일 파일 분석에 실패했습니다",
        load: "이메일을 불러오지 못했습니다",
      },
      field: {
        from: "보낸 사람",
        to: "받는 사람",
        cc: "참조",
        date: "날짜",
        subject_none: "(제목 없음)",
        content_none: "(내용 없음)",
        attachment: "첨부 파일",
        attachments: "첨부 파일",
        unknown: "알 수 없음",
        unknown_type: "알 수 없는 형식",
        none: "없음",
      },
      action: {
        html: "HTML",
        text: "일반 텍스트",
        download_attachment: "첨부 파일 다운로드",
      },
    },
    activity_feed: {
      empty: "활동이 아직 없습니다.",
      direction: {
        inbound: "수신",
        outbound: "발신",
      },
      status: {
        processing: "처리 중",
        failed: "실패",
        completed: "완료",
      },
      label: {
        processing_content: "콘텐츠 처리 중...",
        processing_failed: "처리 실패.",
        audio_recording: "음성 녹음",
        summary: "요약:",
      },
      type: {
        email: "이메일",
        call: "전화",
        sms: "SMS",
        meeting: "회의",
        note: "노트",
      },
    },
    user: {
      action: {
        create: "새 사용자",
        edit: "%{name} 수정",
        resend_invite: "초대장 재발송",
        send_password_reset: "비밀번호 재설정",
        send_reset_link: "재설정 링크 전송",
        cancel: "취소",
        sending: "전송 중...",
        send_invitation: "초대장 전송",
      },
      field: {
        administrator: "관리자",
        disabled: "비활성화됨",
        email_actions: "이메일 동작",
      },
      section: {
        create_title: "새 사용자 만들기",
      },
      empty: {
        title: "사용자를 찾을 수 없음",
        description: "사용자 목록이 비어 있는 것 같습니다.",
      },
      notification: {
        invite_sent: "초대 이메일이 성공적으로 재전송되었습니다",
        created_invite_sent:
          "사용자가 생성되었습니다. 초대 이메일이 발송되었습니다.",
        invite_error: "초대 이메일 재전송에 실패했습니다",
        reset_sent: "비밀번호 재설정 이메일이 성공적으로 전송되었습니다",
        reset_error: "비밀번호 재설정 이메일 전송에 실패했습니다",
        created:
          "사용자가 생성되었습니다. 곧 비밀번호 설정을 위한 이메일이 전송됩니다.",
        create_error: "사용자 생성 중 오류가 발생했습니다.",
        updated: "사용자가 성공적으로 업데이트되었습니다",
        error: "오류가 발생했습니다. 다시 시도해 주세요.",
      },
      dialog: {
        resend_invitation: {
          title: "초대장 재발송",
          description: "%{email}에게 새 초대 이메일을 보내시겠습니까?",
          fresh_link: "계정 설정을 위한 새로운 초대 링크가 전송됩니다.",
        },
        reset_password: {
          title: "비밀번호 재설정 전송",
          description: "%{email}에게 비밀번호 재설정 이메일을 보내시겠습니까?",
          reset_link: "비밀번호를 재설정할 수 있는 링크가 전송됩니다.",
        },
      },
    },
    auth: {
      login_with_code: "코드로 로그인",
      enter_email_for_code: "6자리 로그인 코드를 받으려면 이메일을 입력하세요",
      code_sent: "6자리 코드가 이메일로 발송되었습니다",
      enter_verification_code: "인증 코드 입력",
      code_sent_to: "%{email}로 6자리 코드를 보냈습니다",
      invalid_code:
        "코드가 유효하지 않거나 만료되었습니다. 다시 시도해 주세요.",
      verify_code: "코드 확인",
      verifying: "확인 중...",
      resend_code: "코드 재발송",
      back_to_email: "이메일 입력으로 돌아가기",
      back_to_login: "로그인으로 돌아가기",
      no_access:
        "이 애플리케이션에 대한 접근 권한이 없습니다. 관리자에게 문의하세요.",
      login_successful: "로그인 성공!",
      set_new_password: "새 비밀번호 설정",
      choose_password_details: "계정의 안전한 비밀번호를 선택하세요",
      password_min_length: "비밀번호는 최소 6자 이상이어야 합니다",
      passwords_do_not_match: "비밀번호가 일치하지 않습니다",
      password_updated: "비밀번호가 성공적으로 업데이트되었습니다",
      update_password: "비밀번호 업데이트",
      updating_password: "업데이트 중...",
      failed_to_update_password: "비밀번호 업데이트 실패",
      forgot_password_code_verified:
        "코드가 확인되었습니다! 새 비밀번호를 설정해 주세요.",
      sign_in: "로그인",
      login_otp_link: "이메일 코드(OTP)로 로그인",
      send_code: "코드 발송",
    },
    signup: {
      title: "%{title}에 오신 것을 환영합니다",
      subtitle: "설정을 완료하려면 첫 번째 사용자 계정을 만드십시오.",
      action: {
        create: "계정 만들기",
        creating: "생성 중...",
      },
      notification: {
        success: "첫 번째 사용자가 성공적으로 생성되었습니다",
        error: "오류가 발생했습니다. 다시 시도하십시오.",
      },
    },
    settings: {
      notification: {
        profile_updated: "프로필을 업데이트했습니다",
        error: "에러가 발생했습니다. 다시 시도해주세요",
      },
      action: {
        change_password: "비밀번호 변경",
      },
      inbound_email: {
        title: "인바운드 메일",
        description:
          "서버의 인바운드 메일 주소로 메일을 보내기 시작할 수 있습니다(예: Cc: 필드에 추가). RealTimeX CRM은 메일을 처리하고 해당 연락처에 노트를 추가합니다.",
      },
      database: {
        title: "데이터베이스 연결",
        description: "Supabase 데이터베이스의 연결 설정 및 관리를 수행합니다.",
        connected: "연결됨",
        not_connected: "연결되지 않음",
        no_config: "설정된 Supabase 데이터베이스가 없습니다.",
        configured_on: "%{date}에 설정됨",
        env_hint:
          "환경 변수의 설정을 사용 중입니다. UI를 통해 새 연결을 설정하여 이를 덮어쓸 수 있습니다.",
        setup_hint:
          "RealTimeX CRM 사용을 시작하려면 Supabase 데이터베이스에 연결하십시오. 다음에서 무료 프로젝트를 생성할 수 있습니다.",
        anon_key: "익명 키 (Anon Key)",
        confirm_clear:
          "데이터베이스 설정을 삭제하시겠습니까? 다음 실행 시 앱을 다시 설정해야 합니다.",
        action: {
          change: "연결 변경",
          clear: "설정 삭제",
          connect: "Supabase에 연결",
        },
      },
    },
    migration: {
      banner: {
        title: "데이터베이스 업데이트 가능",
        subtitle: "스키마 v%{version}을(를) 설치할 수 있습니다",
        view_details: "자세히 보기",
        later: "나중에",
        command_copied: "명령을 복사했습니다!",
        dismiss: "닫기",
      },
      modal: {
        title: "데이터베이스 마이그레이션 필요",
        description:
          "데이터베이스 스키마를 v%{version}로 업데이트해야 합니다. 아래 단계에 따라 마이그레이션을 완료하세요.",
        overview: {
          title: "다음이 수행됩니다:",
          update_schema: "데이터베이스 스키마가 v%{version}로 업데이트됩니다",
          enable_features: "새 기능과 개선 사항이 활성화됩니다",
          data_safe: "기존 데이터는 영향을 받지 않습니다",
          duration: "이 과정은 보통 2분 이내입니다",
        },
        prerequisites: {
          title: "사전 준비",
          intro: "다음을 준비하세요:",
          cli_installed: "Supabase CLI 설치됨 (아래 설치 방법 참고)",
          project_id: "Supabase 프로젝트 ID:",
          db_password: "데이터베이스 비밀번호 (요청됨)",
        },
        install_cli: {
          title: "Supabase CLI 설치(미설치 시)",
          macos: "macOS / Linux:",
          windows_scoop: "Windows (Scoop):",
          windows_npm: "Windows (npm):",
          view_all: "모든 설치 방법 보기",
        },
        run_migration: {
          title: "마이그레이션 명령 실행",
          intro: "터미널에서 다음을 실행하세요:",
          tool_intro: "마이그레이션 도구는 다음을 수행합니다:",
          steps: {
            login: "Supabase 로그인 요청(필요 시)",
            project_id: "프로젝트 ID 입력 요청",
            password: "데이터베이스 비밀번호 요청",
            apply: "대기 중인 마이그레이션을 자동으로 적용",
            deploy: "업데이트된 Edge Function 배포",
          },
        },
        refresh: {
          title: "앱 새로고침",
          description:
            "마이그레이션이 완료되면 이 페이지를 새로고침해 새 기능을 이용하세요.",
        },
        troubleshooting: {
          title: "문제 해결:",
          logout_prefix: "로그인 실패 시",
          logout_suffix: "를 실행한 다음 다시 시도하세요",
          password:
            "데이터베이스 비밀번호가 올바른지 확인하세요(Supabase 대시보드에서 확인)",
          report: "문제가 지속되면 다음에 제보하세요:",
          report_link: "GitHub Issues",
        },
        auto: {
          tab_title: "✨ 자동 마이그레이션 (권장)",
          manual_tab_title: "🛠️ 수동 지침",
          title: "원클릭 마이그레이션",
          description: "마이그레이션 스크립트를 자동으로 실행합니다.",
          project_id: "프로젝트 ID",
          access_token: "Supabase 액세스 토큰",
          generate_token: "토큰 생성",
          access_token_hint:
            "CLI에 전역적으로 로그인하지 않은 경우 필요합니다.",
          db_password: "데이터베이스 비밀번호 (선택 사항)",
          db_password_placeholder:
            "프로젝트가 아직 연결되지 않은 경우에만 입력하십시오",
          db_password_hint:
            "이 머신에서 이 프로젝트에 처음 연결하는 경우에만 필요합니다.",
          migrating: "마이그레이션 중...",
          start: "마이그레이션 시작",
          logs_placeholder: "로그가 여기에 표시됩니다...",
          init_log: "🚀 마이그레이션 프로세스 초기화 중...",
          error_prefix: "❌ 오류: ",
          failure_toast: "마이그레이션 실패. 자세한 내용은 로그를 확인하세요.",
          missing_project_id: "구성에서 프로젝트 ID를 확인할 수 없습니다.",
        },
        close: "닫기",
        copy: {
          unsupported:
            "이 환경에서는 복사를 지원하지 않습니다 — 수동으로 복사하세요.",
          success: "클립보드에 복사했습니다!",
          error: "복사에 실패했습니다 — 수동으로 복사하세요.",
          copy_label: "복사",
          copied_label: "복사됨",
        },
      },
    },
    common: {
      activity: "활동",
      contacts: "%{smart_count} 연락처",
      notes: "%{smart_count} 노트",
      deals: "%{smart_count} 거래",
      tasks: "%{smart_count} 작업",
      last_activity: "마지막 활동 %{distance} 전",
      invoices: "%{smart_count} 송장",
      add_contact: "연락처 추가",
      add_invoice: "송장 추가",
    },
  },
  resources: {
    contacts: {
      name: "연락처 |||| 연락처",
      fields: {
        first_name: "이름",
        last_name: "성",
        title: "직함",
        company_id: "회사",
        email: "이메일",
        phone_number: "전화번호",
        linkedin_url: "LinkedIn",
        sales_id: "계정 관리자",
        nb_tasks: "작업",
        last_seen: "최근 활동",
      },
    },
    companies: {
      name: "회사 |||| 회사",
      fields: {
        name: "회사명",
        website: "웹사이트",
        phone_number: "전화번호",
        sector: "섹터",
        size: "규모",
        sales_id: "계정 관리자",
        nb_contacts: "연락처 수",
        nb_deals: "딜 수",
        created_at: "추가일",
        context_links: "컨텍스트 링크",
      },
    },
    deals: {
      name: "딜 |||| 딜",
      fields: {
        name: "딜 이름",
        amount: "금액",
        category: "카테고리",
        stage: "단계",
        company_id: "회사",
        sales_id: "소유자",
      },
    },
    tasks: {
      name: "작업 |||| 작업",
      fields: {
        title: "제목",
        description: "설명",
        type: "유형",
        due_date: "마감일",
        status: "상태",
        priority: "우선순위",
        sales_id: "담당자",
        contact_id: "연락처",
        company_id: "회사",
        deal_id: "딜",
      },
    },
    sales: {
      name: "사용자 |||| 사용자",
      fields: {
        first_name: "이름",
        last_name: "성",
        email: "이메일",
        administrator: "관리자",
        disabled: "비활성화됨",
      },
    },
    invoices: {
      name: "청구서 |||| 청구서",
      fields: {
        invoice_number: "청구서 번호",
        reference: "참조",
        company_id: "회사",
        contact_id: "연락처",
        deal_id: "거래",
        status: "상태",
        issue_date: "발행일",
        due_date: "기한",
        paid_at: "지불일",
        currency: "통화",
        subtotal: "소계",
        discount: "할인",
        tax_total: "세금",
        total: "합계",
        amount_paid: "결제된 금액",
        balance_due: "잔액",
        notes: "메모",
        payment_terms: "지불 조건",
        terms_and_conditions: "이용 약관",
        sent_at: "전송일",
        viewed_at: "조회일",
        created_at: "생성일",
      },
      status: {
        draft: "초안",
        sent: "전송됨",
        paid: "지불됨",
        overdue: "기한 초과",
        cancelled: "취소됨",
      },
      section: {
        details: "상세",
        billing: "청구 대상",
        items: "항목",
        activity: "활동",
        activity_description: "업데이트 및 커뮤니케이션 내역",
        actions: "작업",
        assigned_to: "작성자",
      },
      item: {
        name: "항목",
        description_placeholder: "세부 정보 추가...",
        quantity: "수량",
        unit_price: "단가",
        tax: "세금",
        total: "합계",
        tax_rate: "세율",
      },
      item_type: {
        service: "서비스",
        product: "제품",
        hour: "시간",
        day: "일",
        deposit: "보증금",
      },
      action: {
        new_invoice: "새 청구서",
        add_item: "항목 추가",
        edit: "청구서 수정",
        mark_as_sent: "발송됨으로 표시",
        mark_as_paid: "결제됨으로 표시",
        mark_as_cancelled: "취소됨으로 표시",
        print: "인쇄",
        suggest_number: "번호 제안",
        export_csv: "CSV로 내보내기",
        send_email: "이메일로 보내기",
        download_pdf: "PDF 다운로드",
      },
      notification: {
        status_updated: "송장 상태가 %{status}(으)로 업데이트되었습니다",
        email_sent: "송장 #%{number}이(가) 클라이언트에게 전송되었습니다",
      },
      helper: {
        invoice_number: "고유 청구서 ID",
        reference: "외부 참조 번호 (선택)",
        payment_terms: "예: 30일 이내 결제",
        select_company_for_contacts: "회사를 선택하여 연락처 보기",
        select_company_for_deals: "회사를 선택하여 거래 보기",
      },
      email: {
        subject: "제목",
        body: "메시지 본문",
        description:
          "클라이언트에게 보내기 전에 이메일 메시지를 검토하고 수정하세요.",
        body_intro: "청구서 #%{number}를 첨부하였습니다.",
        message_label: "메시지 (선택 사항)",
        message_placeholder: "개인적인 메시지 추가...",
        message_help:
          "청구서 세부 정보가 포함된 전문적인 이메일이 자동으로 생성됩니다.",
        attachment_title: "PDF 첨부",
        attachment_help: "청구서 %{number}.pdf가 자동으로 첨부됩니다",
        cc: "CC",
        cc_placeholder: "cc@example.com, other@example.com",
      },
      empty_items: "항목이 없습니다",
      days_overdue: "일 초과",
    },
  },
  ra: {
    action: {
      send: "보내기",
      sending: "전송 중...",
      clear_array_input: "목록 지우기",
      confirm: "확인",
      create_item: "%{item} 만들기",
      remove_all_filters: "모든 필터 제거",
      reset: "초기화",
      search_columns: "열 검색",
      select_all: "전체 선택",
      select_all_button: "전체 선택",
      select_row: "이 행 선택",
      unselect: "선택 해제",
      expand: "펼치기",
      close: "닫기",
      open_menu: "메뉴 열기",
      close_menu: "메뉴 닫기",
      update: "업데이트",
      move_up: "위로 이동",
      move_down: "아래로 이동",
      open: "열기",
      toggle_theme: "라이트/다크 모드 전환",
      select_columns: "열",
      update_application: "애플리케이션 새로고침",
    },
    boolean: {
      null: " ",
    },
    page: {
      empty: "%{name}가 아직 없습니다.",
      invite: "추가하시겠습니까?",
      access_denied: "접근 거부",
      authentication_error: "인증 오류",
    },
    input: {
      password: {
        toggle_visible: "비밀번호 숨기기",
        toggle_hidden: "비밀번호 표시",
      },
    },
    message: {
      access_denied: "이 페이지에 접근할 권한이 없습니다.",
      authentication_error:
        "인증 서버가 오류를 반환하여 자격 증명을 확인할 수 없습니다.",
      auth_error: "인증 토큰을 검증하는 동안 오류가 발생했습니다.",
      bulk_update_content:
        "%{name} %{recordRepresentation}을(를) 업데이트하시겠습니까? |||| 이 %{smart_count}개의 항목을 업데이트하시겠습니까?",
      bulk_update_title:
        "%{name} %{recordRepresentation} 업데이트 |||| %{smart_count}개의 %{name} 업데이트",
      clear_array_input: "목록 전체를 지우시겠습니까?",
      select_all_limit_reached:
        "선택할 요소가 너무 많습니다. 처음 %{max}개만 선택되었습니다.",
      unsaved_changes:
        "일부 변경 사항이 저장되지 않았습니다. 무시하시겠습니까?",
      placeholder_data_warning:
        "네트워크 문제: 데이터 새로고침에 실패했습니다.",
    },
    navigation: {
      no_results: "결과가 없습니다.",
      clear_filters: "필터 지우기",
      no_filtered_results: "현재 필터로 %{name}를 찾을 수 없습니다.",
      partial_page_range_info:
        "%{offsetBegin}-%{offsetEnd} / %{offsetEnd} 이상",
      current_page: "페이지 %{page}",
      page: "%{page} 페이지로 이동",
      first: "첫 페이지로 이동",
      last: "마지막 페이지로 이동",
      previous: "이전 페이지로 이동",
      skip_nav: "콘텐츠로 건너뛰기",
    },
    sort: {
      sort_by: "%{field_lower_first} %{order} 정렬",
      ASC: "오름차순",
      DESC: "내림차순",
    },
    auth: {
      auth_check_error: "계속하려면 로그인하세요",
      user_menu: "프로필",
      username: "사용자 이름",
      password: "비밀번호",
      confirm_password: "비밀번호 확인",
      sign_in: "로그인",
      sign_in_error: "인증 실패, 다시 시도하세요",
      logout: "로그아웃",
      email: "이메일",
    },
    notification: {
      i18n_error: "지정된 언어의 번역을 불러올 수 없습니다",
      not_authorized: "이 리소스에 접근할 권한이 없습니다.",
      application_update_available: "새 버전이 사용 가능합니다.",
      offline: "연결 없음. 데이터를 가져올 수 없습니다.",
    },
    validation: {
      unique: "고유해야 합니다",
    },
    saved_queries: {
      label: "저장된 쿼리",
      query_name: "쿼리 이름",
      new_label: "현재 쿼리 저장...",
      new_dialog_title: "현재 쿼리를 다음 이름으로 저장",
      remove_label: "저장된 쿼리 삭제",
      remove_label_with_name: '쿼리 "%{name}" 삭제',
      remove_dialog_title: "저장된 쿼리를 삭제할까요?",
      remove_message: "저장된 쿼리 목록에서 이 항목을 삭제하시겠습니까?",
      help: "목록을 필터링하고 이 쿼리를 저장해 나중에 사용하세요",
    },
    configurable: {
      customize: "사용자 지정",
      configureMode: "이 페이지 구성",
      inspector: {
        title: "검사기",
        content: "UI 요소 위에 마우스를 올려 구성합니다",
        reset: "설정 초기화",
        hideAll: "모두 숨기기",
        showAll: "모두 표시",
      },
      Datagrid: {
        title: "데이터그리드",
        unlabeled: "라벨 없는 열 #%{column}",
      },
      SimpleForm: {
        title: "폼",
        unlabeled: "라벨 없는 입력 #%{input}",
      },
      SimpleList: {
        title: "목록",
        primaryText: "기본 텍스트",
        secondaryText: "보조 텍스트",
        tertiaryText: "세 번째 텍스트",
      },
    },
  },
  "ra-supabase": {
    auth: {
      password_reset: "비밀번호 재설정 메일을 확인하세요.",
    },
    reset_password: {
      forgot_password: "비밀번호를 잊으셨나요?",
      forgot_password_details: "6자리 코드를 받으려면 이메일을 입력하세요.",
    },
  },
};
